import React from 'react';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';
import { useAppSelector } from '../../../app/store';
import { useGetMyProfileQuery } from '../../../services/ProfileService';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { MyApprovalsGrid } from '../components/grids';
import { WriteoffDashboardBackButton } from '../components/commands';

const WriteoffMyApprovals: React.FC = () => {
  const selectedCenter = useAppSelector(state => state.center.selectedCenter);
  const { data: profile, isLoading: profileLoading, error: profileError } = useGetMyProfileQuery();
  const company = profile?.organization || '';

  // Loading state
  if (profileLoading) {
    return (
      <PageContainer>
        <PageCard>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Loading profile...</Typography>
          </Box>
        </PageCard>
      </PageContainer>
    );
  }

  // Error state
  if (profileError) {
    return (
      <PageContainer>
        <PageCard>
          <Alert severity="error" sx={{ mb: 3 }}>
            Error loading profile information. Please refresh the page and try again.
          </Alert>
        </PageCard>
      </PageContainer>
    );
  }

  // No center selected state
  if (!selectedCenter) {
    return (
      <PageContainer>
        <PageCard>
          <Alert severity="warning" sx={{ mb: 3 }}>
            Please select a center to view your writeoff approvals.
          </Alert>
        </PageCard>
      </PageContainer>
    );
  }

  // No company profile state
  if (!company) {
    return (
      <PageContainer>
        <PageCard>
          <Alert severity="warning" sx={{ mb: 3 }}>
            Company information not available. Please ensure your profile is properly configured.
          </Alert>
        </PageCard>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageCard>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
          <Box>
            <Typography variant="h4" sx={{ color: '#1e293b', fontWeight: 600, mb: 1 }}>
              My Approvals
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b' }}>
              Writeoffs requiring your review and approval in {selectedCenter}
            </Typography>
          </Box>
          <WriteoffDashboardBackButton
            company={company}
            center={selectedCenter}
          />
        </Box>

        {/* Grid */}
        <MyApprovalsGrid />
      </PageCard>
    </PageContainer>
  );
};

export default WriteoffMyApprovals;
